import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'

const ConnectorHotSpotModal = ({ connector_views, setConnectorHotSpot }) => {
  return (
    <Modal
      onClose={() => {
        setConnectorHotSpot([])
      }}
      show={true}
    >
      <ModalHeader className={'text-white'}>Hot Spot</ModalHeader>
      <ModalBody>
        <div>
          <ul className="max-h-12">
            {connector_views?.map((connector_view, connector_view_idx) => {
              return (
                <li
                  className="text-white cursor-pointer"
                  key={`connector_view-${connector_view_idx}`}
                >
                  {connector_view}
                </li>
              )
            })}
          </ul>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ConnectorHotSpotModal
